<template>
    <div class="tooltip" :title="title">
        {{ label }}
        <div v-if="!title" class="tooltip-content" :class="position">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            position: {
                type: String,
                default: 'right'
            },
            label: {
                type: String,
                default: '?'
            },
            title: {
                type: String,
                default: null
            }
        }
    }
</script>

<style scoped>
    .tooltip {
        cursor: help;
        position:relative;
        text-align:left;
        font-size: 10px;
        font-weight: bold;
        height: 15px;
        width: 15px;
        background: #f5f8fa;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid #bdbdbd;
        top: -5px;
    }

    .tooltip-content {
        @apply bg-gray-100;

        width: 360px;
        max-width: 70vw;
        padding: 10px 20px;
        font-size:13px;
        border-radius:8px;
        position:absolute;
        z-index:99999999;
        box-sizing:border-box;
        box-shadow:0 1px 8px rgba(0,0,0,0.5);
        display:none;
    }
    
    .tooltip-content.right {
        top: 50%;
        transform: translate(0, -50%);
        margin-left: 20px;
        left: 100%;
    }

    .tooltip-content.left {
        top:50%;
        transform:translate(0, -50%);
        margin-right: 20px;
        right: 100%;
    }

    .tooltip-content.top {
        left:50%;
        transform:translate(-50%, 0);
        margin-bottom: 20px;
        bottom: 100%;
    }

    .tooltip-content.bottom {
        left:50%;
        transform:translate(-50%, 0);
        margin-top: 20px;
        top: 100%;
    }

    .tooltip:hover .tooltip-content {
        display:block;
    }

    @media (max-width: theme('screens.sm')) {
        .tooltip .tooltip-content {
            position: fixed;
            top: 20%;
            left: 0;
            right: 0;
            bottom: auto;
            margin: 0 auto;
            transform: none;
        }
    }

    .tooltip-content i {
        position:absolute;
        top:50%;
        right:100%;
        margin-top:-12px;
        width:12px;
        height:24px;
        overflow:hidden;
    }

    .tooltip-content i::after {
        @apply bg-gray-100;

        content:'';
        position:absolute;
        width:12px;
        height:12px;
        left:0;
        top:50%;
        transform:translate(50%,-50%) rotate(-45deg);
        box-shadow:0 1px 8px rgba(0,0,0,0.5);
    }
</style>